module.exports = __webpack_public_path__ + "static/media/dhnMungo.9b4ecad2.png";